import axios, { AxiosResponse } from 'axios';
import { FetchLoungesType } from '../redux/lounges/slice';
import { Lounge } from '../redux/lounges/types';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { normalizeApiPage } from './pagination';
import { LOUNGE_GET_TIMEOUT_MS } from '../utils/loungeRequest';
import { buildLoungeAuthHeaders } from '../utils/loungeAuthHeader';
export const getDisnyworldLoungesApi = async ({
  sortType,
  LoungeId,
  currentPage,
  searchValue,
  shortByTime,
}: FetchLoungesType) => {
  const responseBody = (response: AxiosResponse) => response.data;
  localStorage.setItem('pagename', 'Wdw Talk');
  let sorvalue = null;
  const token = localStorage.getItem('token');
  const page = normalizeApiPage(currentPage);
  let sortByTime =
    shortByTime == 'true'
      ? `?page=${page}&sortordefault=ww`
      : `?page=${page}`;
  const apiEndpoint = GET_BASE_URL + `/api/v1/disneyworldHome`;

  if (searchValue != null) {
    const { data } = await axios
      .get<Lounge[]>(`${apiEndpoint}/search/post/${searchValue}${sortByTime}`, {
        headers: {
          ...buildLoungeAuthHeaders(token),
        },
        timeout: LOUNGE_GET_TIMEOUT_MS,
      })
      .then(responseBody);
    return data.data;
  } else {
    const { data } = await axios
      .get<Lounge[]>(`${apiEndpoint}${sortByTime}`, {
        headers: {
          ...buildLoungeAuthHeaders(token),
        },
        timeout: LOUNGE_GET_TIMEOUT_MS,
      })
      .then(responseBody);

    return data.data;
  }
};
